export default __webpack_public_path__ + "static/media/Vector.31a38770.svg";